import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface CustomShippingFieldParameter extends ApiParameter {
    receiverContactName?: string;
}

export interface CustomShippingFieldModel {
    receiverContactName?: string;
}

type HandlerType = CustomApiHandler<CustomShippingFieldParameter, CustomShippingFieldModel>;

export const DispatShippingReciverContactName: HandlerType = (props: any) => {
    props.dispatch({
        type: "ShippingPage/CustomFields/receiverConatactName",
        result: props.parameter.receiverContactName,
    });
};

export const chain = [DispatShippingReciverContactName];

const customShippingFieldReceiverName = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "CustomShippingFieldReceiverName",
);
export default customShippingFieldReceiverName;
